import React, { useEffect, useRef, useState } from "react";
import SiteLogo from "./common/SiteLogo";
import anime from "animejs";
import Footer from "./Footer";
import SocialIcon from "./common/SocialIcon";
import MenuSocialIcons from "./common/MenuSocialIcons";
import WeekendModeContent from "./common/WeekendModeContent";
import ProfilePortrait from "./common/ProfilePortrait";
import WeekendPortrait from "./common/WeekendPortrait";
import { Link } from "react-router-dom";

const Home = () => {
  const textWrapperRef = useRef(null);
  const profileImage = `${process.env.PUBLIC_URL}/haseeb.png`;
  const [isBurgerClicked, setIsBurgerClicked] = useState(false);

  const handleBurgerClick = () => {
    setIsBurgerClicked((prevClicked) => !prevClicked);
  };

  //Home Page Heading functionality.
  useEffect(() => {
    const textWrapper = textWrapperRef.current;
    if (textWrapper) {
      const textContent = "Haseeb Sajjad";
      textWrapper.innerHTML = textContent
        .split("")
        .map((char, index) =>
          char === " " ? " " : `<span class='letter'>${char}</span>`
        )
        .join("");

      anime
        .timeline({ loop: true })
        .add({
          targets: ".ml3 .letter",
          opacity: [0, 1],
          easing: "easeInOutQuad",
          duration: 2250,
          delay: (el, i) => 150 * (i + 1),
        })
        .add({
          targets: ".ml3",
          opacity: 0,
          duration: 1000,
          easing: "easeOutExpo",
          delay: 1000,
        });
    }
  }, []);

  // Download CV functionality
  const onButtonClick = () => {
    // using Java Script method to get PDF file
    fetch("resume.pdf").then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);

        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "resume.pdf";
        alink.click();
      });
    });
  };

  return (
    <>
      <div className="salva-page-wrap">
        <section className="salva-fixed-content" id="home_page">
          <div className="container-fluid">
            <div className="row home-content-row">
              {/* <!--Left side salva fixed image start here--> */}
              <div className="col-12 col-md-5 col-lg-4 col-xxl-5 salva-left-fixed-image p-0">
                <h1 className="d-none">this is a image of salva fixed</h1>
                <ProfilePortrait />
                <WeekendPortrait />
              </div>
              {/* <!--Left side salva fixed image end here --> */}
              {/* <!--right side salva content start here--> */}
              <div className="col-12 col-md-12 col-lg-8 col-xxl-7 salva-home-content dark-home-content p-0">
                <div
                  className={`salva-home-wrap ${
                    isBurgerClicked ? "border-none" : ""
                  }`}
                >
                  <div className="salva-home-main-content">
                    <h2
                      className="mb-0 salv-home-title salv-dark-home-title lg-font w-text inter-font-900 ml3"
                      ref={textWrapperRef}
                    >
                      Haseeb Sajjad
                    </h2>
                    <p className="mb-0 salv-home-desc w-text inter-font-500">
                      Full Stack Developer with 3+ years of experience building
                      web apps, business tools, and automated workflows. I work
                      with React, Next.js, Node.js, MongoDB, and WordPress to
                      create modern and scalable solutions.
                    </p>
                    {/* <!--small screen social icon start here --> */}
                    <div className="salv-tablet-view-soci">
                      <div className="salv-social-content">
                        <MenuSocialIcons listClassName="salv-social-list" iconClassName="salv-social-icon" />
                      </div>
                    </div>
                    <div className="salv-home-buttons dark-button">
                      <div className="salv-home-get-touch dark-get-touch">
                        <Link to="/contact" target="_self">
                          <span className="salv-get-text">get in touch</span>
                        </Link>
                      </div>
                      <button
                        className="salv-down-cv-btn dark-down-btn"
                        onClick={onButtonClick}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_101_176)">
                            <path
                              d="M16 2L21 7V21.008C20.9997 21.2712 20.895 21.5235 20.7088 21.7095C20.5226 21.8955 20.2702 22 20.007 22H3.993C3.73038 21.9982 3.47902 21.8931 3.29322 21.7075C3.10742 21.5219 3.00209 21.2706 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16ZM13 12V8H11V12H8L12 16L16 12H13Z"
                              fill="#ffffff"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_101_176">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>{" "}
                        download cv{" "}
                      </button>
                    </div>
                  </div>
                  {/* <!--weekend-mode start here--> */}
                  <WeekendModeContent />
                  {/* <!--social icon start here --> */}
                  <SocialIcon />
                  {/* <!--footer content start here --> */}
                  <Footer />
                </div>

                {/* <!--header content start here --> */}
                <header className="salva-header salv-home-header salv-dark-header">
                  <div className="container p-0">
                    <div className="row">
                      <div className="col-6 col-sm-4 col-md-4 col-lg-4">
                        <a className="salva-logo" href="/">
                          <SiteLogo />
                        </a>
                      </div>
                      <div className="col-6 col-sm-8 col-md-8 col-lg-8">
                        <nav className="navbar salva-header-nav dark-salv-header">
                          <div className="d-flex">
                            <input
                              type="checkbox"
                              id="navcheck"
                              className="navcheck"
                              role="button"
                              title="menu"
                              aria-pressed="true"
                            />
                            <label
                              htmlFor="navcheck"
                              aria-hidden="true"
                              title="menu"
                            >
                              <span
                                className={`salv-burger dark-salv-burger ${
                                  isBurgerClicked ? "click" : ""
                                }`}
                                onClick={handleBurgerClick}
                              >
                                <span className="bar dark-bar">
                                  <span className="visuallyhidden">Menu</span>
                                </span>
                              </span>
                            </label>
                            {/* <!--Desktop screen menu design --> */}
                            <ul
                              id="menu"
                              className="sal-menu-list dark-sal-menu-list"
                            >
                              <li className="salv-menu-item">
                                <Link
                                  to="/"
                                  target="_self"
                                  className="w-text salv-menu-link dark-menu-link active"
                                >
                                  Home
                                </Link>
                              </li>
                              <li className="salv-menu-item">
                                <Link
                                  to="/about"
                                  target="_self"
                                  className="salv-menu-link dark-color"
                                >
                                  About
                                </Link>
                              </li>
                              <li className="salv-menu-item">
                                <Link
                                  to="/portfolio"
                                  target="_self"
                                  className="salv-menu-link dark-color"
                                >
                                  Portfolio
                                </Link>
                              </li>
                              <li className="salv-menu-item">
                                <Link
                                  to="/contact"
                                  target="_self"
                                  className="salv-menu-link dark-color"
                                >
                                  Contact
                                </Link>
                              </li>
                            </ul>
                            {/* <!--tablet screen menu design --> */}
                            <div className="salv-menu-design-two">
                              <div className="menu-design-wrap">
                                <div className="salv-menu-profile">
                                  <img
                                    src={profileImage}
                                    alt="Haseeb Sajjad profile"
                                  />
                                </div>
                                <div className="sakv-new-menu-social">
                                    <MenuSocialIcons />
                                  </div>
                                <div className="salv-menu-list">
                                  <ul className="salv-sec-menu-item">
                                    <li className="salv-sec-menu-link">
                                      <Link
                                        to="/"
                                        className="slav-tb-menu-name"
                                        target="_self"
                                      >
                                        home
                                      </Link>
                                    </li>
                                    <li className="salv-sec-menu-link">
                                      <Link
                                        to="/about"
                                        target="_self"
                                        className="slav-tb-menu-name"
                                      >
                                        about
                                      </Link>
                                    </li>
                                    <li className="salv-sec-menu-link">
                                      <Link
                                        to="/portfolio"
                                        target="_self"
                                        className="slav-tb-menu-name"
                                      >
                                        portfolio
                                      </Link>
                                    </li>
                                    <li className="salv-sec-menu-link">
                                      <Link
                                        to="/contact"
                                        target="_self"
                                        className="slav-tb-menu-name"
                                      >
                                        contact
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                                <div className="salv-mob-copyright">
                                  <p className="salv-copyright-content mb-0 sm-font inter-font-400 b-text light-copyright">
                                    Copyright © 2025 Haseeb Sajjad{" "}
                                    
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </nav>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
              {/* <!--right side salva content end here --> */}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default Home;
